// Checkout.js
import React, { useState } from "react";
import { Button } from "@mui/material";
import Header from "../Header/Header";
import NavBar from "../NavBar/NavBar";
import Footer from "../Footer/Footer";
import "./CheckOut.css";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import AddressForm from "./AddressForm";
import PaymentForm from "./PaymentForm";
import Review from "./Review";
import Typography from "@mui/material/Typography";

function Checkout() {
  const steps = ["Shipping address", "Payment details", "Review your order"];
  const [shippingDetails, setShippingDetails] = useState({});
  const [paymentDetails, setPaymentDetails] = useState({});
  const [orderPlaced, setOrderPlaced] = useState(false);

  const getStepContent = (step) => {
    switch (step) {
      case 0:
        return (
          <AddressForm
            setShippingDetails={setShippingDetails}
            handleNext={handleNext}
          />
        );
      case 1:
        return (
          <PaymentForm
            setPaymentDetails={setPaymentDetails}
            handleNext={handleNext}
          />
        );
      case 2:
        return (
          <Review
            shippingDetails={shippingDetails}
            paymentDetails={paymentDetails}
          />
        );
      default:
        throw new Error("Unknown step");
    }
  };

  const [activeStep, setActiveStep] = React.useState(0);

  const handleNext = () => {
    // Save form data to local storage before moving to the next step
    if (activeStep === 0) {
      localStorage.setItem("shippingDetails", JSON.stringify(shippingDetails));
    } else if (activeStep === 1) {
      localStorage.setItem("paymentDetails", JSON.stringify(paymentDetails));
    }

    setActiveStep(activeStep + 1);
  };

  const handleBack = () => {
    // Remove form data from local storage when going back
    if (activeStep === 1) {
      localStorage.removeItem("shippingDetails");
    } else if (activeStep === 2) {
      localStorage.removeItem("paymentDetails");
    }

    setActiveStep(activeStep - 1);
  };

  const handleSubmit = () => {
    // Handle submission logic here if needed

    // Clear the form data from local storage after the order is placed
    localStorage.removeItem("shippingDetails");
    localStorage.removeItem("paymentDetails");

    // Set the orderPlaced state to true
    setOrderPlaced(true);

    // Additional logic can be added as needed
  };

  return (
    <div>
    <Header />
    <NavBar />
    <React.Fragment>
      <CssBaseline />
      <Container component="main" maxWidth="sm" sx={{ mb: 4 }}>
        <Paper
          variant="outlined"
          sx={{ my: { xs: 3, md: 6 }, p: { xs: 2, md: 3 } }}
        >
          <Typography component="h1" variant="h4" align="center">
            Checkout
          </Typography>
          <Stepper activeStep={activeStep} sx={{ pt: 3, pb: 5 }}>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          {orderPlaced ? (
            <React.Fragment>
              <Typography variant="h5" gutterBottom>
                Thank you for your order.
              </Typography>
              <Typography variant="subtitle1">
                Your order number is #2001539. We have emailed your order
                confirmation, and will send you an update when your order has
                shipped.
              </Typography>
            </React.Fragment>
          ) : (
            <React.Fragment>
              {getStepContent(activeStep)}
              <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                {activeStep !== 0 && (
                  <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                    Back
                  </Button>
                )}
                {activeStep === steps.length - 1 && (
                  <Button
                    variant="contained"
                    onClick={handleSubmit}
                    sx={{ mt: 3, ml: 1 }}
                  >
                    Place order
                  </Button>
                )}
              </Box>
            </React.Fragment>
          )}
        </Paper>
      </Container>
    </React.Fragment>
    <Footer />
  </div>
  );
}

export default Checkout;
